import { render, staticRenderFns } from "./aws-form.vue?vue&type=template&id=4d43bf1f"
import script from "./aws-form.vue?vue&type=script&lang=js"
export * from "./aws-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports